import { render, staticRenderFns } from "./TotalTypesSingleRowTable.vue?vue&type=template&id=0251b794&scoped=true&"
import script from "./TotalTypesSingleRowTable.vue?vue&type=script&lang=js&"
export * from "./TotalTypesSingleRowTable.vue?vue&type=script&lang=js&"
import style0 from "./TotalTypesSingleRowTable.vue?vue&type=style&index=0&id=0251b794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0251b794",
  null
  
)

export default component.exports